import axios from "axios";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ComponentType } from "@constants/ComponentType";
import { HandleType } from "@constants/HandleType";
import { useALError } from "@helpers/ErrorBoundary/ALErrorBoundary";
import { GIFT_PACKAGES_HANDLES } from "@constants/GiftPackages";

function EmergencyDaily({ productHandle, productType, showPreOrderFomo, componentType }) {
  const { sendReport } = useALError();
  const [unitSold, setUnitSold] = useState(null);

  const emergencyText = showPreOrderFomo
    ? `High demand style, ${unitSold} preorders in the last 24 hours`
    : `${unitSold} items purchased in the last 24 hours`;

  useEffect(() => {
    if (!unitSold && productHandle && productType) {
      axios
        .get(`/.netlify/functions/unit-sold?handle=${productHandle}&type=${productType}`)
        .then((r) => {
          setUnitSold(r?.data?.units);
        })
        .catch((err) => {
          console.log(err);
          sendReport(err, { name: "EmergencyDaily", priority: "P5" });
        });
    }
  }, [unitSold, productHandle, productType]);

  if (
    !unitSold ||
    GIFT_PACKAGES_HANDLES.includes(productHandle) ||
    productHandle === HandleType.GIFT_CARD
  ) {
    return null;
  }

  return (
    <div
      className={`pdp_emergency flex flex-row items-center justify-center gap-[10px] bg-[#ffddce] py-[5px] rounded-lg desktop:mx-[20px] ${
        componentType === ComponentType.PDP_ADS ? "mobile:flex mobile:mx-[15px]" : "mobile:hidden"
      }`}
    >
      <div className="relative w-2 h-2">
        <div className="absolute h-3 w-3 -top-0.5 -right-0.5 animate-pulse-emergency rounded-full">
          &nbsp;
        </div>
        <div className="bg-secondary w-2 h-2 rounded-full">&nbsp;</div>
      </div>
      <p className="font-normal text-[10px] leading-[14px] desktop:text-xs desktop:leading-[14px]">
        {emergencyText}
      </p>
    </div>
  );
}

EmergencyDaily.propTypes = {
  productHandle: PropTypes.string.isRequired,
  productType: PropTypes.string.isRequired,
  componentType: PropTypes.string,
  showPreOrderFomo: PropTypes.bool,
};

export default EmergencyDaily;
